export const genId = () => Math.random().toString(36).slice(2);
